import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import { CustomLoader } from '../utils/CommonLibrary';
import { decryptData } from '../utils/Utils';
import { fetchRefillPoolData } from '../../services/hih/Service';
import CalendarDatePicker from '../componenents/CalendarDatePicker';
import BackendDrivenDataTable from '../cn/components/common/BackendDrivenDataTable';
import AddMember from './AddMember';

const RefillPool = () => {
    const storedDates = localStorage.getItem('selectedDates') ? JSON.parse(decryptData(localStorage.getItem('selectedDates'))) : '';

    const [startDate, setStartDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[0]) : moment().subtract(6, 'days')
    );
    const [endDate, setEndDate] = useState(
        storedDates && storedDates.length === 4 ? moment(storedDates[1]) : moment()
    );

    const navigate = useNavigate();
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedCurrentStatus, setSelectedCurrentStatus] = useState('memberaccepted');
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMembershipNo, setSelectedMembershipNo] = useState("");

    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("createdTime");
    const [sortDirection, setSortDirection] = useState('desc');

    useEffect(() => {
        getList(formatDate(startDate), formatDate(endDate))
    }, [page, perPage, sortColumn, sortDirection, selectedCurrentStatus, startDate, endDate])

    const handleTabSelect = (index) => {
        setSelectedIndex(index);
        navigate(`${location.pathname}?tab=${index}`, { replace: true });
    };

    const handleDateChange = ({ start, end }) => {
        //setPageNumber(1);
        setStartDate(start);
        setEndDate(end);

        getList(formatDate(start), formatDate(end), 1);
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const getList = async (startDate, endDate) => {
        try {
            setListData([]);
            setLoading(true);

            fetchRefillPoolData(selectedCurrentStatus, startDate, endDate, page, perPage, sortColumn, sortDirection)
                .then((response) => {
                    if (response.data.code == 200) {
                        setListData(response.data.data.members);
                        setTotalRows(response.data.data.totalRows)
                    }
                }).finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error=', error);
        }
    }
    const getPool = () => {

    }

    const columns = [
        {
            cell: row => (
                <button class="action-button blue-btn me-2" onClick={() => {
                    if (row.currentStatus == "due") {
                        window.location.href = `/rf-member-profile?mno=${row.membershipNo}`;
                    } else {
                        setSelectedMembershipNo(row.membershipNo);
                        setShowModal(true);
                    }
                }}>{row.currentStatus === "due" ? "Recommend" : "Onboard"}
                </button >
            ),
            sortable: false,
        },
        {
            name: 'Member ID',
            selector: row => row.membershipNo,
            sortable: true,
        },
        {
            name: 'Main Membership No',
            selector: row => row.mainMembershipNo,
            sortable: true,
        },
        {
            name: 'Member Name',
            selector: row => row.memberName,
            sortable: true,
        },
        {
            name: 'Mobile',
            selector: row => row.memberMobile,
            sortable: true,
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: true,
        },
        {
            name: 'Age',
            selector: row => row.age,
            sortable: true,
        },
        {
            name: 'VIP Code',
            selector: row => row.vipCode,
            sortable: true,
        },
        {
            name: 'Ambassador',
            selector: row => row.ambassadorInd,
            sortable: true,
        },
        {
            name: 'ID Card No',
            selector: row => row.idCardNo,
            sortable: true,
        },
        {
            name: 'Net Type',
            selector: row => row.netType,
            sortable: true,
        },
        {
            name: 'Contract No',
            selector: row => row.contractNo,
            sortable: false,
        },
        {
            name: 'Customer Name',
            selector: row => row.customerName,
            sortable: false,
        },
        {
            name: 'Contract Term Date',
            selector: row => row.contractTermDate,
            sortable: false,
        },
        {
            name: 'WhatsApp Sent Date',
            selector: row => row.WASentTime,
            sortable: false,
        },
        {
            name: 'WhatsApp Reply Date',
            selector: row => row.WAReplyTime,
            sortable: false,
        }
    ];
    return (
        <>
            <section className='ContentCareNavigator'>
                <div className="row align-items-center pb-3 sticky-top-bar">
                    <div className="col-md">
                        <h1 className="main-title">Refill Pool</h1>
                    </div>
                    <div className="col-md text-end">

                    </div>
                </div>

                <div className='reports-programs mb-3'>
                    <div className="row align-items-center">
                        <div className="col-md-auto">
                            <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/5jw18/wh4l7e7hk4.png" alt="Invited Members icon" style={{ height: "140px" }} className="img-fluid mb-0" />
                        </div>
                        <div className="col-md">
                            <p className="mb-0">The Refill Pool module allows you to onboard the not-onboarded users and manage the service recommendations.</p>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row align-items-center pb-3">
                        <div className='comntent-CareNavigator mb-3'>
                            <div className="row">
                                <div className="col-md-2">
                                    Pool Members Type:
                                </div>
                                <div className="col-md-3">
                                    <select className='form-control'>
                                        <option value="memberaccepted">Members who accepted</option>
                                        <option value="memberdeclined">Members who declined</option>
                                        <option value="whatsappmessagesent">Members who did not respond</option>
                                    </select>
                                </div>
                                <div className='col-md-3'>
                                    <CalendarDatePicker startDate={startDate} endDate={endDate} onDateChange={handleDateChange} />
                                </div>
                                <div className='col-md-3'>
                                    <Button variant="primary" className="btn btn-primary add-new-program-btn me-2" type="button" onClick={() => getPool()}
                                    >Get Pool</Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <Tabs selectedIndex={selectedIndex} onSelect={index => handleTabSelect(index)}>
                                        <TabList>
                                            <Tab onClick={() => {
                                                setListData([]);
                                                setSelectedCurrentStatus("memberaccepted");
                                            }}>Members who accepted</Tab>
                                            <Tab onClick={() => {
                                                setListData([]);
                                                setSelectedCurrentStatus("memberdeclined");
                                            }}>Members who declined</Tab>
                                            <Tab onClick={() => {
                                                setListData([]);
                                                setSelectedCurrentStatus("whatsappmessagesent");
                                            }}>Members did not respond</Tab>
                                        </TabList>
                                        <TabPanel style={{ padding: "10px 0px" }}>
                                            <div className="table-responsive CareNavigatorListTable">
                                                {/*Member Accepted*/}
                                                {
                                                    selectedCurrentStatus == "memberaccepted" &&
                                                    <div className="col-md-12">
                                                        <div className="table-responsive MemberTransferTable">
                                                            {

                                                                <div>
                                                                    {
                                                                        loading ? <CustomLoader /> :
                                                                            <BackendDrivenDataTable
                                                                                data={listData}
                                                                                loading={loading}
                                                                                totalRows={totalRows}
                                                                                page={page}
                                                                                perPage={perPage}
                                                                                sortColumn={sortColumn}
                                                                                sortDirection={sortDirection}
                                                                                columns={columns}
                                                                                fetchTableData={getList}
                                                                                setPage={setPage}
                                                                                setSortColumn={setSortColumn}
                                                                                setSortDirection={setSortDirection}
                                                                                setPerPage={setPerPage}
                                                                            />
                                                                    }
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel style={{ padding: "10px 12px" }}>
                                            <div className="table-responsive CareNavigatorListTable">
                                                {/*Member Declined*/}
                                                {
                                                    selectedCurrentStatus == "memberdeclined" &&
                                                    <div className="col-md-12">
                                                        <div className="table-responsive MemberTransferTable">
                                                            {

                                                                <div>
                                                                    {
                                                                        loading ? <CustomLoader /> :
                                                                            <BackendDrivenDataTable
                                                                                data={listData}
                                                                                loading={loading}
                                                                                totalRows={totalRows}
                                                                                page={page}
                                                                                perPage={perPage}
                                                                                sortColumn={sortColumn}
                                                                                sortDirection={sortDirection}
                                                                                columns={columns}
                                                                                fetchTableData={getList}
                                                                                setPage={setPage}
                                                                                setSortColumn={setSortColumn}
                                                                                setSortDirection={setSortDirection}
                                                                                setPerPage={setPerPage}
                                                                            />
                                                                    }
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel style={{ padding: "10px 12px" }}>
                                            <div className="table-responsive CareNavigatorListTable">
                                                {/*Member Not Interested*/}
                                                {
                                                    selectedCurrentStatus == "whatsappmessagesent" &&
                                                    <div className="col-md-12">
                                                        <div className="table-responsive MemberTransferTable">
                                                            {

                                                                <div>
                                                                    {
                                                                        loading ? <CustomLoader /> :
                                                                            <BackendDrivenDataTable
                                                                                data={listData}
                                                                                loading={loading}
                                                                                totalRows={totalRows}
                                                                                page={page}
                                                                                perPage={perPage}
                                                                                sortColumn={sortColumn}
                                                                                sortDirection={sortDirection}
                                                                                columns={columns}
                                                                                fetchTableData={getList}
                                                                                setPage={setPage}
                                                                                setSortColumn={setSortColumn}
                                                                                setSortDirection={setSortDirection}
                                                                                setPerPage={setPerPage}
                                                                            />
                                                                    }
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showModal && selectedMembershipNo != "" && <AddMember status="add" heading="Add New Member" hideModal={() => {
                setShowModal(false);
                setSelectedMembershipNo("");
            }} membershipNumber={selectedMembershipNo} currentStatus={selectedCurrentStatus} />
            }
        </>
    )
}

export default RefillPool